<div class="modal-header" id="interims-limit-modal-title">
    <h3 class="modal-title" id="modal-title" translate="INTERIMS_LIMIT_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <div class="row">
        <div class="col center-text" translate="INTERIMS_LIMIT_MESSAGE"></div>
    </div>
    <div class="row">
        <ul class="col">
            @for (interim of interims; track interim) {
                <li class="center-text mt-1">{{ interim.Equipment }}</li>
            }
        </ul>
    </div>
</div>
<div class="modal-footer">
    <div class="row">
        <div class="col-12">
            <button
                type="button"
                class="btn btn-primary"
                (click)="modalInstance.hide()"
                translate="INTERIMS_LIMIT_BUTTON_OK"
            ></button>
        </div>
    </div>
</div>
